export const GET_ERRORS = "GET_ERRORS";
// User

// Get Bank List
export const GET_BANK_LIST = "GET_BANK_LIST";
export const GET_BANK_LIST_SUCCESS = "GET_BANK_LIST_SUCCESS";
export const GET_BANK_LIST_FAIL = "GET_BANK_LIST_FAIL";

// Get User Account Info
export const GET_ACCOUNT_INFO = "GET_ACCOUNT_INFO";

// Fetch ALL coins available
export const FETCH_COINS = "FETCH_COINS";
export const FETCH_COINS_FAIL = "FETCH_COINS_FAIL";

// Fetch ALL coins available
export const FETCH_COINS_PRICE = "FETCH_COINS_PRICE";
export const FETCH_COIN_PRICE_FAIL = "FETCH_COIN_PRICE_FAIL";


// Post Transaction to API
export const CREATE_TRANSACTION = "CREATE_TRANSACTION";
export const CREATE_TRANSACTION_SUCCESS = "CREATE_TRANSACTION_SUCCESS";
export const CREATE_TRANSACTION_FAIL = "CREATE_TRANSACTION_FAIL";

// Converter 
export const CONVERT_COIN = "CONVERT_COIN";

// USER
//USER ACTIONS
export const USER_REGISTER = "USER_REGISTER";
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL";
export const USER_REGISTER_CLEANUP = "USER_REGISTER_CLEANUP";

export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const USER_LOGIN_CLEANUP = "USER_LOGIN_CLEANUP";

export const USER_LOGOUT = "USER_LOGOUT";
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";
export const USER_LOGOUT_FAIL = "USER_LOGOUT_FAIL";
export const USER_LOGOUT_CLEANUP = "USER_LOGOUT_CLEANUP";

export const USER_FORGOT_PASSWORD = "USER_FORGOT_PASSWORD";
export const USER_FORGOT_PASSWORD_SUCCESS = "USER_FORGOT_PASSWORD_SUCCESS";
export const USER_FORGOT_PASSWORD_FAIL = "USER_FORGOT_PASSWORD_FAIL";
export const USER_FORGOT_PASSWORD_CLEANUP = "USER_FORGOT_PASSWORD_CLEANUP";

export const SET_CURRENT_USER_USER = "SET_CURRENT_USER_USER";

export const USER_RESET_FORGOT_PASSWORD = "USER_RESET_FORGOT_PASSWORD";
export const USER_RESET_PASSWORD = "USER_RESET_PASSWORD";
export const GET_USER_DATA = "GET_USER_DATA";
export const USER_UPLOAD_DOC = "USER_UPLOAD_DOC";

export const USER_GET_CLIENT = "USER_GET_CLIENT";
export const USER_GET_CLIENT_SUCCESS = "USER_GET_CLIENT_SUCCESS";
export const USER_GET_CLIENT_FAIL = "USER_GET_CLIENT_FAIL";
export const USER_GET_CLIENT_CLEANUP = "USER_GET_CLIENT_CLEANUP";

export const USER_GET_CLIENT_DETAILS = "USER_GET_CLIENT_DETAILS";
export const USER_GET_CLIENT_DETAILS_SUCCESS =
  "USER_GET_CLIENT_DETAILS_SUCCESS";
export const USER_GET_CLIENT_DETAILS_FAIL = "USER_GET_CLIENT_DETAILS_FAIL";
export const USER_GET_CLIENT_DETAILS_CLEANUP =
  "USER_GET_CLIENT_DETAILS_CLEANUP";




// Get Auth User
export const GET_AUTHENTICATED_USER = "GET_AUTHENTICATED_USER";
export const GET_AUTHENTICATED_USER_FAIL = "GET_AUTHENTICATED_USER_FAIL";

// Change Pasword
export const USER_CHANGE_PASSWORD_SUCCESS = "USER_CHANGE_PASSWORD_SUCCESS";
export const USER_CHANGE_PASSWORD_FAIL = "USER_CHANGE_PASSWORD_FAIL";

// Fetch ALL coins available
export const FETCH_AUTH_COINS = "FETCH_AUTH_COINS";
export const FETCH_AUTH_COINS_FAIL = "FETCH_AUTH_COINS_FAIL";


// Fetch Each Coin
export const FETCH_EACH_AUTH_COIN_SUCCESS = "FETCH_EACH_AUTH_COIN_SUCCESS";
export const FETCH_EACH_AUTH_COIN_FAIL = "FETCH_EACH_AUTH_COIN_FAIL";


// Fetch All Transactions
export const FETCH_ALL_TRANSACTIONS = "FETCH_ALL_TRANSACTIONS";
export const FETCH_ALL_TRANSACTIONS_SUCCESS = "FETCH_ALL_TRANSACTIONS_SUCCESS";
export const FETCH_ALL_TRANSACTIONS_FAIL = "FETCH_ALL_TRANSACTIONS_FAIL";